import { Spinner } from "react-bootstrap";

const CustomSpinner = () => {
    return (
        <div className="overlay-spinner">
            <Spinner animation="border" variant="primary" />
            <span className="loading-text">Cargando...</span>
        </div>
    );
}

export default CustomSpinner;